import {useEffect} from "react";

// eslint-disable-next-line react-hooks/exhaustive-deps
export const useMountEffect = effect => useEffect(effect, []);
// eslint-disable-next-line react-hooks/exhaustive-deps
export const useUnmountEffect = effect => useEffect(()=>effect, []);